module.exports = __webpack_public_path__ + "img/up-white.fa0f049d.jpg";